import { render, staticRenderFns } from "./batch_form.vue?vue&type=template&id=0b1d4b76&lang=pug"
import script from "./batch_form.vue?vue&type=script&lang=js"
export * from "./batch_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports